import React, { useEffect, useRef } from "react";
import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import MatchLiveScoringDialog from "src/components/MatchLiveScoringDialog";
import useWithUrlTenant from "src/hooks/useTenant";

const MatchLiveScoringPage = () => {
  const navigate = useNavigate();
  const showMatch = useSelector((state) => state.fixtures.selectedMatch);
  const withTenant = useWithUrlTenant();
  const previousTenantIdRef = useRef(null);



  // Detect tenant changes and navigate to fixtures page
  useEffect(() => {
    // Only navigate if withTenant has changed (meaning tenantId changed) and not on initial mount
    if (previousTenantIdRef.current !== null) {
      navigate(withTenant("/dashboard/fixtures"));
    }

    // Mark that we've initialized
    previousTenantIdRef.current = true;
  }, [withTenant, navigate]);

  const handleClose = () => {
    navigate(withTenant("/dashboard/fixtures"));
  };

  if (!showMatch) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography variant="h6">No match</Typography>
        <Typography
          variant="button"
          sx={{ cursor: "pointer", color: "primary.main", mt: 2 }}
          onClick={() => navigate(withTenant("/dashboard/fixtures"))}
        >
          Go Back
        </Typography>
      </Box>
    );
  }

  return (
    <MatchLiveScoringDialog
      open={true}
      onClose={handleClose}
      showMatch={showMatch}
    />
  );
};

export default MatchLiveScoringPage;
